import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import '@/index.css';
import '@/i18n';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/contexts/ThemeContext';

// Pages
import ScanPage from '@/pages/ScanPage';
import PresentationPage from '@/pages/PresentationPage';
import EmployeeDashboard from '@/pages/EmployeeDashboard';
import EmployeeTimeclock from '@/pages/EmployeeTimeclock';
import EmployeeOffTicket from '@/pages/EmployeeOffTicket';
import EmployeeHistory from '@/pages/EmployeeHistory';
import EmployeeLeaves from '@/pages/EmployeeLeaves';
import EmployeeIdeas from '@/pages/EmployeeIdeas';
import EmployeeScanWoPage from '@/pages/employee/EmployeeScanWoPage';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminEmployees from '@/pages/AdminEmployees';
import AdminTimesheets from '@/pages/AdminTimesheets';
import AdminLeaves from '@/pages/AdminLeaves';
import AdminLocations from '@/pages/AdminLocations';
import ClientsPage from '@/pages/garage/ClientsPage';
import RelancesPage from '@/pages/garage/RelancesPage';
import ClientDetailPage from '@/pages/garage/ClientDetailPage';
import VehiclesPage from '@/pages/garage/VehiclesPage';
import AgendaPage from '@/pages/garage/AgendaPage';
import AgendaPrintPage from '@/pages/garage/AgendaPrintPage';
import AgendaPeriodPrintPage from '@/pages/garage/AgendaPeriodPrintPage';
import AgendaTvPage from '@/pages/garage/AgendaTvPage';
import WorkOrderDetailPrintPage from '@/pages/garage/WorkOrderDetailPrintPage';
import AdminPunchPage from '@/pages/garage/AdminPunchPage';
import WorkOrdersListPage from '@/pages/garage/WorkOrdersListPage';
import DeletionRequestsPage from '@/pages/garage/DeletionRequestsPage';
import ScanAttachmentPage from '@/pages/public/ScanAttachmentPage';
import WorkOrderPage from '@/pages/garage/WorkOrderPage';
import NotificationsPage from '@/pages/garage/NotificationsPage';
import RappelsPage from '@/pages/garage/RappelsPage';
import BankReconciliationPage from '@/pages/garage/BankReconciliationPage';
import ComptaPage from '@/pages/garage/ComptaPage';
import AccountingExportPage from '@/pages/garage/AccountingExportPage';
import GeolocationPage from '@/pages/garage/GeolocationPage';
import AbsenceCalendarPage from '@/pages/garage/AbsenceCalendarPage';
import BackupPage from '@/pages/garage/BackupPage';
import KpiDashboardPage from '@/pages/garage/KpiDashboardPage';
import WeeklyReportPage from '@/pages/garage/WeeklyReportPage';
import MarketplacePage from '@/pages/garage/MarketplacePage';
import ClientResponsePage from '@/pages/public/ClientResponsePage';
import MechanicScanPage from '@/pages/public/MechanicScanPage';
import ScanCarteGrisePage from '@/pages/public/ScanCarteGrisePage';
import ScanUsedVehiclePage from '@/pages/public/ScanUsedVehiclePage';
import ScanSupplierInvoicePage from '@/pages/public/ScanSupplierInvoicePage';
import WorkshopDashboard from '@/pages/garage/WorkshopDashboard';
import FinanceDashboard from '@/pages/garage/FinanceDashboard';
import InventoryPage from '@/pages/garage/InventoryPage';
import BillingPage from '@/pages/garage/BillingPage';
import CompanySettingsPage from '@/pages/garage/CompanySettingsPage';
import TimeTrackingPage from '@/pages/garage/TimeTrackingPage';
import SupplierInvoicesPage from '@/pages/garage/SupplierInvoicesPage';
import PayslipPage from '@/pages/garage/PayslipPage';
import GeneralExpensesPage from '@/pages/garage/GeneralExpensesPage';
import WhatsAppPage from '@/pages/garage/WhatsAppPage';
import WhatsappTemplatesPage from '@/pages/garage/WhatsappTemplatesPage';
import WhatsAppSettingsPage from '@/pages/garage/WhatsAppSettingsPage';
import ReceptionDashboard from '@/pages/garage/ReceptionDashboard';
import SatisfactionPage from '@/pages/public/SatisfactionPage';
import NewSatisfactionPage from '@/pages/SatisfactionPage';
import SignWorkOrderPage from '@/pages/public/SignWorkOrderPage';
import TimeclockPage from '@/pages/public/TimeclockPage';
import MobileCheckInPage from '@/pages/public/MobileCheckInPage';
import MobileCheckOutPage from '@/pages/public/MobileCheckOutPage';
import WoClockPage from '@/pages/public/WoClockPage';
import ScanBulletinPage from '@/pages/public/ScanBulletinPage';
import WorkshopPlanningPage from '@/pages/garage/WorkshopPlanningPage';
import UsedVehiclesPage from '@/pages/garage/UsedVehiclesPage';
import SuppliersPage from '@/pages/garage/SuppliersPage';
import PurchaseOrdersPage from '@/pages/garage/PurchaseOrdersPage';
import CommandesAdminPage from '@/pages/garage/CommandesAdminPage';
import ReportsPage from '@/pages/garage/ReportsPage';
import InsightsPage from '@/pages/garage/InsightsPage';
import SuperAdminLogin from '@/pages/superadmin/SuperAdminLogin';
import SuperAdminDashboard from '@/pages/superadmin/SuperAdminDashboard';
import SuperAdminTenants from '@/pages/superadmin/SuperAdminTenants';
import SuperAdminPayments from '@/pages/superadmin/SuperAdminPayments';
import SuperAdminLogs from '@/pages/superadmin/SuperAdminLogs';
import SuperAdminPlans from '@/pages/superadmin/SuperAdminPlans';
import SuperAdminHealth from '@/pages/superadmin/SuperAdminHealth';
import SuperAdminCommunications from '@/pages/superadmin/SuperAdminCommunications';
import AtelierLogin from '@/pages/atelier/AtelierLogin';
import AtelierGardiennage from '@/pages/atelier/AtelierGardiennage';
import AtelierClients from '@/pages/atelier/AtelierClients';
import AtelierWorkOrderDetail from '@/pages/atelier/AtelierWorkOrderDetail';
import AtelierCommandes from '@/pages/atelier/AtelierCommandes';
import AtelierPointage from '@/pages/atelier/AtelierPointage';
import MobileScanUpload from '@/pages/MobileScanUpload';
import ComptaScanMobile from '@/pages/ComptaScanMobile';
import SalesDashboard from '@/pages/admin/SalesDashboard';
import EmployeeHRPage from '@/pages/admin/EmployeeHRPage';
import ObjectivesManager from '@/pages/admin/ObjectivesManager';
import TimeclockQRDisplay from '@/pages/public/TimeclockQRDisplay';
import SecureTimeclock from '@/pages/SecureTimeclock';
import AdminTimeclock from '@/pages/garage/AdminTimeclock';
import UsedTiresPage from '@/pages/garage/UsedTiresPage';
import SatisfactionAdminPage from '@/pages/garage/SatisfactionAdminPage';

function App() {
  // Restore auth from localStorage synchronously to avoid redirect flicker on reload
  const [employeeAuth, setEmployeeAuth] = useState(() => {
    const t = localStorage.getItem('employee_token'), d = localStorage.getItem('employee_data');
    return t && d ? { token: t, employee: JSON.parse(d) } : null;
  });
  const [adminAuth, setAdminAuth] = useState(() => {
    const t = localStorage.getItem('admin_token'), d = localStorage.getItem('admin_data');
    return t && d ? { token: t, admin: JSON.parse(d) } : null;
  });
  const [superAdminAuth, setSuperAdminAuth] = useState(() => {
    const t = localStorage.getItem('superadmin_token'), d = localStorage.getItem('superadmin_data');
    return t && d ? { token: t } : null;
  });
  const [atelierAuth, setAtelierAuth] = useState(() => !!localStorage.getItem('atelier_employee'));

  useEffect(() => {
    const atelierEmployee = localStorage.getItem('atelier_employee');
    if (atelierEmployee) {
      setAtelierAuth(true);
    }

    // Listen for plan upgrade events
    const handleUpgrade = (e) => {
      const { toast } = require('sonner');
      toast.error(e.detail.message, { duration: 6000 });
    };
    window.addEventListener('plan-upgrade-required', handleUpgrade);
    return () => window.removeEventListener('plan-upgrade-required', handleUpgrade);
  }, []);

  const handleEmployeeLogin = (token, employee) => {
    localStorage.setItem('employee_token', token);
    localStorage.setItem('employee_data', JSON.stringify(employee));
    setEmployeeAuth({ token, employee });
    // Also set atelier auth so mechanics can access workshop
    localStorage.setItem('atelier_employee', JSON.stringify({
      id: employee.id,
      name: `${employee.first_name} ${employee.last_name}`.trim(),
      email: employee.email,
      role: employee.role,
      token: token,
    }));
    setAtelierAuth(true);
  };

  const handleAdminLogin = (token, admin) => {
    localStorage.setItem('admin_token', token);
    localStorage.setItem('admin_data', JSON.stringify(admin));
    setAdminAuth({ token, admin });
  };

  const handleEmployeeLogout = () => {
    localStorage.removeItem('employee_token');
    localStorage.removeItem('employee_data');
    setEmployeeAuth(null);
  };

  const handleAdminLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_data');
    setAdminAuth(null);
  };

  const handleSuperAdminLogin = (token, admin) => {
    localStorage.setItem('superadmin_token', token);
    localStorage.setItem('superadmin_data', JSON.stringify(admin));
    setSuperAdminAuth({ token, admin });
  };

  const handleSuperAdminLogout = () => {
    localStorage.removeItem('superadmin_token');
    localStorage.removeItem('superadmin_data');
    setSuperAdminAuth(null);
  };

  const handleAtelierLogin = (token) => {
    setAtelierAuth(true);
  };

  const handleAtelierLogout = () => {
    localStorage.removeItem('atelier_employee');
    setAtelierAuth(null);
  };

  const isAdmin = adminAuth?.admin?.role === 'admin' || (!adminAuth?.admin?.role && adminAuth?.admin?.is_admin);
  const isAdminOrRh = isAdmin || adminAuth?.admin?.role === 'rh';
  const isAtelier = adminAuth?.admin?.role === 'atelier';
  const defaultRedirect = isAtelier ? '/admin/work-orders' : '/admin/clients';
  const adminOnly = (Component) => {
    if (!adminAuth) return <Navigate to="/admin/login" />;
    if (!isAdmin) return <Navigate to={defaultRedirect} />;
    return Component;
  };
  const adminOrRhOnly = (Component) => {
    if (!adminAuth) return <Navigate to="/admin/login" />;
    if (!isAdminOrRh) return <Navigate to={defaultRedirect} />;
    return Component;
  };

  return (
    <ThemeProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ScanPage onLogin={handleEmployeeLogin} />} />
          <Route path="/scan" element={<ScanPage onLogin={handleEmployeeLogin} />} />
          <Route path="/presentation" element={<PresentationPage />} />
          <Route path="/scan-upload/:token" element={<MobileScanUpload />} />
          <Route path="/compta-scan/:sessionId" element={<ComptaScanMobile />} />
          <Route path="/satisfaction/:token" element={<NewSatisfactionPage />} />
          
          <Route
            path="/employee/dashboard"
            element={
              employeeAuth ? (
                <EmployeeDashboard auth={employeeAuth} onLogout={handleEmployeeLogout} />
              ) : (
                <Navigate to="/scan" />
              )
            }
          />
          <Route
            path="/employee/timeclock"
            element={
              employeeAuth ? (
                <SecureTimeclock auth={employeeAuth} />
              ) : (
                <Navigate to="/scan" />
              )
            }
          />
          <Route
            path="/employee/offticket"
            element={
              employeeAuth ? (
                <EmployeeOffTicket auth={employeeAuth} onLogout={handleEmployeeLogout} />
              ) : (
                <Navigate to="/scan" />
              )
            }
          />
          <Route
            path="/employee/history"
            element={
              employeeAuth ? (
                <EmployeeHistory auth={employeeAuth} onLogout={handleEmployeeLogout} />
              ) : (
                <Navigate to="/scan" />
              )
            }
          />
          <Route
            path="/employee/leaves"
            element={
              employeeAuth ? (
                <EmployeeLeaves auth={employeeAuth} onLogout={handleEmployeeLogout} />
              ) : (
                <Navigate to="/scan" />
              )
            }
          />
          
          <Route
            path="/employee/ideas"
            element={
              employeeAuth ? (
                <EmployeeIdeas auth={employeeAuth} onLogout={handleEmployeeLogout} />
              ) : (
                <Navigate to="/scan" />
              )
            }
          />
          <Route
            path="/employee/scan-wo"
            element={
              employeeAuth ? (
                <EmployeeScanWoPage />
              ) : (
                <Navigate to="/scan" />
              )
            }
          />
          
          <Route path="/admin/login" element={<AdminLogin onLogin={handleAdminLogin} />} />
          <Route
            path="/admin/dashboard"
            element={<Navigate to="/admin/reception-dashboard" replace />}
          />
          <Route
            path="/admin/employees"
            element={adminOrRhOnly(<AdminEmployees auth={adminAuth} onLogout={handleAdminLogout} />)}
          />
          <Route
            path="/admin/employees/:employeeId/hr"
            element={adminOrRhOnly(<EmployeeHRPage auth={adminAuth} onLogout={handleAdminLogout} />)}
          />
          <Route
            path="/admin/timesheets"
            element={adminOrRhOnly(<AdminTimesheets auth={adminAuth} onLogout={handleAdminLogout} />)}
          />
          <Route
            path="/admin/leaves"
            element={adminOrRhOnly(<AdminLeaves auth={adminAuth} onLogout={handleAdminLogout} />)}
          />
          <Route
            path="/admin/locations"
            element={adminOrRhOnly(<AdminLocations auth={adminAuth} onLogout={handleAdminLogout} />)}
          />
          {/* Garage management routes */}
          <Route path="/admin/reception-dashboard" element={adminAuth ? <ReceptionDashboard auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/clients" element={adminAuth ? <ClientsPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/clients/:clientId" element={adminAuth ? <ClientDetailPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/relances" element={adminAuth ? <RelancesPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/vehicles" element={adminAuth ? <VehiclesPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/agenda" element={adminAuth ? <AgendaPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/agenda/print" element={adminAuth ? <AgendaPrintPage /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/agenda/tv" element={adminAuth ? <AgendaTvPage /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/agenda/print-list" element={adminAuth ? <AgendaPeriodPrintPage /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/work-orders" element={adminAuth ? <WorkOrdersListPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/deletion-requests" element={adminOnly(<DeletionRequestsPage auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/timbreuse" element={adminAuth ? <AdminPunchPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/work-orders/:woId/detail" element={adminAuth ? <WorkOrderDetailPrintPage /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/work-orders/:woId" element={adminAuth ? <WorkOrderPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/notifications" element={adminAuth ? <Navigate to="/admin/whatsapp-templates" replace /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/rappels" element={adminAuth ? <RappelsPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/rappels-service" element={<Navigate to="/admin/rappels" replace />} />
          <Route path="/admin/rappels-pneus" element={<Navigate to="/admin/rappels" replace />} />
          <Route path="/admin/export-comptable" element={adminAuth ? <AccountingExportPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/bank-reconciliation" element={adminAuth ? <BankReconciliationPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/comptabilite" element={adminAuth ? <ComptaPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/geolocalisation" element={adminAuth ? <GeolocationPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/calendrier-absences" element={adminAuth ? <AbsenceCalendarPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/backup" element={adminAuth ? <BackupPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/kpi" element={adminAuth ? <KpiDashboardPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/rapport-hebdo" element={adminAuth ? <WeeklyReportPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/marketplace" element={adminAuth ? <MarketplacePage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/finance" element={adminOnly(<FinanceDashboard auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/inventory" element={adminAuth ? <InventoryPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/suppliers" element={adminAuth ? <SuppliersPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/purchase-orders" element={adminAuth ? <PurchaseOrdersPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/commandes-besoins" element={adminAuth ? <CommandesAdminPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/reports" element={adminOnly(<ReportsPage auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/insights" element={adminAuth ? <InsightsPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/billing" element={adminAuth ? <BillingPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/supplier-invoices" element={adminOnly(<SupplierInvoicesPage auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/payslips" element={adminOnly(<PayslipPage />)} />
          <Route path="/admin/general-expenses" element={adminOnly(<GeneralExpensesPage auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/whatsapp" element={adminOnly(<WhatsAppPage auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/whatsapp-settings" element={adminOnly(<WhatsAppSettingsPage auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/whatsapp-templates" element={adminOnly(<WhatsappTemplatesPage auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/settings" element={adminOnly(<CompanySettingsPage auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/my-dashboard" element={adminAuth ? <SalesDashboard auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/objectives" element={adminOnly(<ObjectivesManager />)} />
          <Route path="/admin/workshop" element={adminAuth ? <WorkshopDashboard auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/workshop/:woId" element={adminAuth ? <TimeTrackingPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/workshop-planning" element={adminAuth ? <WorkshopPlanningPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/used-vehicles" element={adminAuth ? <UsedVehiclesPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/admin/timeclock" element={adminOnly(<AdminTimeclock auth={adminAuth} onLogout={handleAdminLogout} />)} />
          <Route path="/admin/satisfaction" element={adminOnly(<SatisfactionAdminPage auth={adminAuth} onLogout={handleAdminLogout} />)} />
          {/* Legacy section routes redirect to reception dashboard */}
          {['realtime', 'leave-requests', 'messages', 'summaries', 'recent'].map((sec) => (
            <Route
              key={sec}
              path={`/admin/${sec}`}
              element={<Navigate to="/admin/reception-dashboard" replace />}
            />
          ))}
          {/* Public client response page (no auth required) */}
          <Route path="/respond/:token" element={<ClientResponsePage />} />
          <Route path="/scan/:woId" element={<MechanicScanPage />} />
          <Route path="/scan-carte-grise/:sessionId" element={<ScanCarteGrisePage />} />
          <Route path="/scan-used-vehicle/:sessionId" element={<ScanUsedVehiclePage />} />
          <Route path="/scan-attachment/:sessionId" element={<ScanAttachmentPage />} />
          <Route path="/scan-facture/:sessionId" element={<ScanSupplierInvoicePage />} />
          <Route path="/feedback/:surveyId" element={<SatisfactionPage />} />
          <Route path="/sign/:woId" element={<SignWorkOrderPage />} />
          <Route path="/timeclock" element={<TimeclockPage />} />
          <Route path="/reception-mobile" element={<MobileCheckInPage />} />
          <Route path="/restitution-mobile" element={<MobileCheckOutPage />} />
          <Route path="/timeclock-qr" element={<TimeclockQRDisplay />} />
          <Route path="/wo-clock" element={<WoClockPage />} />
          <Route path="/scan-bulletin/:woId/:orderId" element={<ScanBulletinPage />} />
          {/* Super Admin routes */}
          <Route path="/superadmin/login" element={<SuperAdminLogin onLogin={handleSuperAdminLogin} />} />
          <Route path="/superadmin/dashboard" element={superAdminAuth ? <SuperAdminDashboard auth={superAdminAuth} onLogout={handleSuperAdminLogout} /> : <Navigate to="/superadmin/login" />} />
          <Route path="/superadmin/tenants" element={superAdminAuth ? <SuperAdminTenants auth={superAdminAuth} onLogout={handleSuperAdminLogout} /> : <Navigate to="/superadmin/login" />} />
          <Route path="/superadmin/payments" element={superAdminAuth ? <SuperAdminPayments auth={superAdminAuth} onLogout={handleSuperAdminLogout} /> : <Navigate to="/superadmin/login" />} />
          <Route path="/superadmin/logs" element={superAdminAuth ? <SuperAdminLogs auth={superAdminAuth} onLogout={handleSuperAdminLogout} /> : <Navigate to="/superadmin/login" />} />
          <Route path="/superadmin/plans" element={superAdminAuth ? <SuperAdminPlans auth={superAdminAuth} onLogout={handleSuperAdminLogout} /> : <Navigate to="/superadmin/login" />} />
          <Route path="/superadmin/health" element={superAdminAuth ? <SuperAdminHealth auth={superAdminAuth} onLogout={handleSuperAdminLogout} /> : <Navigate to="/superadmin/login" />} />
          <Route path="/superadmin/communications" element={superAdminAuth ? <SuperAdminCommunications auth={superAdminAuth} onLogout={handleSuperAdminLogout} /> : <Navigate to="/superadmin/login" />} />
          {/* Atelier (Workshop) routes */}
          <Route path="/atelier" element={<AtelierLogin onLogin={handleAtelierLogin} />} />
          <Route path="/atelier/planning" element={atelierAuth ? <AgendaPrintPage atelier /> : <Navigate to="/atelier" />} />
          <Route path="/atelier/planning-sheet" element={<Navigate to="/atelier/planning" replace />} />
          <Route path="/atelier/tv" element={atelierAuth ? <AgendaTvPage atelier /> : <Navigate to="/atelier" />} />
          <Route path="/atelier/pointage" element={atelierAuth ? <AtelierPointage onLogout={handleAtelierLogout} /> : <Navigate to="/atelier" />} />
          <Route path="/atelier/work-orders" element={<Navigate to="/atelier/planning" replace />} />
          <Route path="/atelier/work-orders/:woId" element={atelierAuth ? <AtelierWorkOrderDetail onLogout={handleAtelierLogout} /> : <Navigate to="/atelier" />} />
          <Route path="/atelier/preparations" element={<Navigate to="/atelier/planning" replace />} />
          <Route path="/atelier/stock" element={<Navigate to="/atelier/planning" replace />} />
          <Route path="/atelier/gardiennage" element={atelierAuth ? <AtelierGardiennage onLogout={handleAtelierLogout} /> : <Navigate to="/atelier" />} />
          <Route path="/atelier/pneus-occasion" element={atelierAuth ? <UsedTiresPage atelier onLogout={handleAtelierLogout} /> : <Navigate to="/atelier" />} />
          <Route path="/admin/used-tires" element={adminAuth ? <UsedTiresPage auth={adminAuth} onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />} />
          <Route path="/atelier/clients" element={atelierAuth ? <AtelierClients onLogout={handleAtelierLogout} /> : <Navigate to="/atelier" />} />
          <Route path="/atelier/commandes" element={atelierAuth ? <AtelierCommandes onLogout={handleAtelierLogout} /> : <Navigate to="/atelier" />} />
          <Route path="/atelier/stock-alerts" element={<Navigate to="/atelier/planning" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
    </ThemeProvider>
  );
}

export default App;
